import type { ChannelId, CompareId, LocationId, LocKpis } from './types'

export const C_MOCK = {
  blue: '#2563EB',
  blueLt: '#3B82F6',
  blueDk: '#1D4ED8',
  green: '#10B981',
  red: '#EF4444',
  orange: '#F59E0B',
  purple: '#8B5CF6',
  teal: '#0EA5E9',
  t2: '#475569',
  t3: '#94A3B8',
}

export const LOCATIONS: { id: LocationId; label: string; short: string; city: string }[] = [
  { id: 'all', label: 'All Locations', short: 'All Locations', city: 'All' },
  { id: 'vancouver', label: 'Green Tree Cannabis – Vancouver', short: 'Vancouver', city: 'Vancouver' },
  { id: 'richmond', label: 'Green Tree Cannabis – Richmond', short: 'Richmond', city: 'Richmond' },
  { id: 'burnaby', label: 'Burnaby Cannabis Co.', short: 'Burnaby', city: 'Burnaby' },
  { id: 'north-shore', label: 'North Shore Dispensary', short: 'North Shore', city: 'North Van' },
]

export const LOC_KPIS: Record<LocationId, LocKpis> = {
  all: {
    totalRev: 259400, onlineRev: 86800, inStoreRev: 172600,
    orders: 1847, onlineOrders: 614, inStoreOrders: 1233,
    aov: 77.31, convRate: 3.2,
    customers: 3241, newCust: 892, repeatRate: 68.4, ltv: 187,
    deliveries: 1280, completedDel: 1126, avgDelTime: 34, onTimeRate: 91.2,
    cancelled: 81, pending: 142, avgItems: 2.4,
  },
  vancouver: {
    totalRev: 108900, onlineRev: 36500, inStoreRev: 72400,
    orders: 776, onlineOrders: 258, inStoreOrders: 518,
    aov: 80.4, convRate: 3.8,
    customers: 1360, newCust: 374, repeatRate: 71.2, ltv: 201,
    deliveries: 538, completedDel: 478, avgDelTime: 28, onTimeRate: 94.0,
    cancelled: 32, pending: 58, avgItems: 2.6,
  },
  richmond: {
    totalRev: 72600, onlineRev: 24300, inStoreRev: 48300,
    orders: 517, onlineOrders: 172, inStoreOrders: 345,
    aov: 75.8, convRate: 3.0,
    customers: 907, newCust: 249, repeatRate: 66.8, ltv: 174,
    deliveries: 358, completedDel: 316, avgDelTime: 34, onTimeRate: 91.0,
    cancelled: 22, pending: 40, avgItems: 2.3,
  },
  burnaby: {
    totalRev: 46700, onlineRev: 15600, inStoreRev: 31100,
    orders: 332, onlineOrders: 110, inStoreOrders: 222,
    aov: 74.2, convRate: 2.8,
    customers: 583, newCust: 160, repeatRate: 67.1, ltv: 179,
    deliveries: 230, completedDel: 202, avgDelTime: 31, onTimeRate: 92.0,
    cancelled: 14, pending: 26, avgItems: 2.2,
  },
  'north-shore': {
    totalRev: 31200, onlineRev: 10400, inStoreRev: 20800,
    orders: 222, onlineOrders: 74, inStoreOrders: 148,
    aov: 78.9, convRate: 2.4,
    customers: 389, newCust: 109, repeatRate: 68.2, ltv: 182,
    deliveries: 154, completedDel: 130, avgDelTime: 42, onTimeRate: 88.0,
    cancelled: 13, pending: 18, avgItems: 2.1,
  },
}

export const LOC_SCALE: Record<LocationId, number> = {
  all: 1,
  vancouver: 0.42,
  richmond: 0.28,
  burnaby: 0.18,
  'north-shore': 0.12,
}

export const T: Record<CompareId, Record<string, number>> = {
  'last-period': {
    totalRev: 12.4, onlineRev: 14.6, inStoreRev: 10.1,
    orders: 8.2, aov: 3.8, margin: 1.2, convRate: 0.4,
    customers: 6.4, newCust: 11.2, repeatRate: 2.1, ltv: 5.3,
    sessions: 18.4, clicks: 12.1, impressions: 22.6, avgPos: -0.4,
    deliveries: 9.8, completedDel: 11.2, avgDelTime: -3.4, onTimeRate: 1.8,
    cancelled: -8.4, pending: -12.4, avgItems: 1.2,
  },
  'last-month': {
    totalRev: 18.2, onlineRev: 22.4, inStoreRev: 15.8,
    orders: 14.1, aov: 3.5, margin: 2.1, convRate: 1.2,
    customers: 12.8, newCust: 18.6, repeatRate: 4.2, ltv: 8.1,
    sessions: 28.4, clicks: 22.1, impressions: 34.6, avgPos: -0.8,
    deliveries: 16.4, completedDel: 18.8, avgDelTime: -5.2, onTimeRate: 2.4,
    cancelled: -14.2, pending: -8.2, avgItems: 2.1,
  },
  'last-year': {
    totalRev: 42.1, onlineRev: 68.4, inStoreRev: 28.2,
    orders: 38.4, aov: 2.9, margin: 4.8, convRate: 4.8,
    customers: 28.4, newCust: 42.1, repeatRate: 8.6, ltv: 18.4,
    sessions: 84.2, clicks: 112.4, impressions: 142.6, avgPos: -1.4,
    deliveries: 48.2, completedDel: 52.4, avgDelTime: -12.4, onTimeRate: 6.8,
    cancelled: -28.4, pending: -22.1, avgItems: 4.2,
  },
}

export const CMP_LABEL: Record<CompareId, string> = {
  'last-period': 'vs. last period',
  'last-month': 'vs. last month',
  'last-year': 'vs. last year',
}

export const revenueTimeline = [
  { date: 'Mar 1', online: 4200, inStore: 8100 },
  { date: 'Mar 3', online: 3800, inStore: 7600 },
  { date: 'Mar 5', online: 5100, inStore: 9200 },
  { date: 'Mar 7', online: 4600, inStore: 8800 },
  { date: 'Mar 9', online: 6200, inStore: 10100 },
  { date: 'Mar 11', online: 5800, inStore: 9400 },
  { date: 'Mar 13', online: 7100, inStore: 11200 },
  { date: 'Mar 15', online: 6400, inStore: 10600 },
  { date: 'Mar 17', online: 8200, inStore: 12100 },
  { date: 'Mar 19', online: 7600, inStore: 11800 },
  { date: 'Mar 21', online: 9100, inStore: 13200 },
  { date: 'Mar 23', online: 8700, inStore: 12400 },
]

export const revByDow = [
  { day: 'Mon', online: 6200, inStore: 11400 },
  { day: 'Tue', online: 5800, inStore: 10200 },
  { day: 'Wed', online: 7100, inStore: 12600 },
  { day: 'Thu', online: 6400, inStore: 11800 },
  { day: 'Fri', online: 9200, inStore: 16400 },
  { day: 'Sat', online: 11400, inStore: 19800 },
  { day: 'Sun', online: 8600, inStore: 14200 },
]

export const categoryPie = [
  { name: 'Flower', value: 35, color: C_MOCK.blue },
  { name: 'Pre-Rolls', value: 25, color: C_MOCK.blueLt },
  { name: 'Vapes', value: 20, color: C_MOCK.purple },
  { name: 'Edibles', value: 12, color: C_MOCK.green },
  { name: 'Other', value: 8, color: C_MOCK.t3 },
]

export const topProducts = [
  { name: 'Blue Dream Pre-Roll 1g', cat: 'Pre-Rolls', brand: 'Redecan', rev: 12400, orders: 248, margin: 47, stock: 142, status: 'in-stock' as const, trend: 12 },
  { name: 'OG Kush Flower 3.5g', cat: 'Flower', brand: 'Pure Sunfarms', rev: 10200, orders: 170, margin: 38, stock: 88, status: 'in-stock' as const, trend: 8 },
  { name: 'Sour Diesel Vape Cart', cat: 'Vapes', brand: 'HEXO', rev: 9800, orders: 163, margin: 44, stock: 21, status: 'low-stock' as const, trend: -3 },
  { name: 'CBD Sleep Tincture 30ml', cat: 'Tinctures', brand: 'Medipharm', rev: 8600, orders: 215, margin: 41, stock: 64, status: 'in-stock' as const, trend: 21 },
  { name: 'Mango Haze Edibles 10pk', cat: 'Edibles', brand: 'Foray', rev: 7400, orders: 185, margin: 35, stock: 0, status: 'out-of-stock' as const, trend: 5 },
  { name: 'Indica Pre-Roll 5pk', cat: 'Pre-Rolls', brand: '1964 Supply Co.', rev: 6800, orders: 136, margin: 49, stock: 108, status: 'in-stock' as const, trend: -1 },
  { name: 'Pink Kush Shatter 1g', cat: 'Concentrates', brand: 'Shred', rev: 6200, orders: 103, margin: 45, stock: 14, status: 'low-stock' as const, trend: 18 },
  { name: 'Strawberry Haze Vape', cat: 'Vapes', brand: 'Spinach', rev: 5800, orders: 116, margin: 43, stock: 47, status: 'in-stock' as const, trend: 7 },
]

export const categoryRevBar = [
  { cat: 'Flower', rev: 48200 },
  { cat: 'Pre-Rolls', rev: 34600 },
  { cat: 'Vapes', rev: 27700 },
  { cat: 'Edibles', rev: 16600 },
  { cat: 'Tinctures', rev: 9800 },
  { cat: 'Other', rev: 5300 },
]

export const GA4_PROPERTIES = [
  { id: 'GA4-283947561', name: 'Green Tree Cannabis – All Properties', domain: 'greentreecannabis.ca', sessions: '8,420', conv: '3.2%' },
  { id: 'GA4-283947562', name: 'Green Tree Cannabis – Vancouver', domain: 'vancouver.greentreecannabis.ca', sessions: '3,892', conv: '3.8%' },
  { id: 'GA4-283947563', name: 'Green Tree Cannabis – Richmond', domain: 'richmond.greentreecannabis.ca', sessions: '2,614', conv: '3.0%' },
  { id: 'GA4-283947564', name: 'Burnaby Cannabis Co.', domain: 'burnabycannabis.ca', sessions: '1,914', conv: '2.8%' },
]

export const GSC_SITES = [
  { url: 'https://greentreecannabis.ca/', verified: true, clicks: 2890, impressions: '89.4k' },
  { url: 'https://greentreecannabis.ca/vancouver/', verified: true, clicks: 1420, impressions: '41.2k' },
  { url: 'https://greentreecannabis.ca/richmond/', verified: false, clicks: 840, impressions: '24.8k' },
  { url: 'https://burnabycannabis.ca/', verified: true, clicks: 630, impressions: '18.6k' },
]

export const WIDGETS = [
  { id: 'kpis', label: 'KPI Summary', section: 'revenue', default: true, locked: true },
  { id: 'revenue-chart', label: 'Revenue Over Time', section: 'revenue', default: true },
  { id: 'channel-split', label: 'Channel Split', section: 'revenue', default: true },
  { id: 'category-pie', label: 'Sales by Category', section: 'revenue', default: true },
  { id: 'top-products', label: 'Top Products', section: 'revenue', default: true },
  { id: 'cart-recovery', label: 'Cart Recovery', section: 'revenue', default: false },
  { id: 'rev-by-dow', label: 'Revenue by Day', section: 'revenue', default: false },
  { id: 'customer-kpis', label: 'Customer Metrics', section: 'customers', default: true },
  { id: 'seo-banner', label: 'Website Performance', section: 'website', default: true },
  { id: 'seo-chart', label: 'Organic Traffic Chart', section: 'website', default: false },
  { id: 'top-keywords', label: 'Top Keywords', section: 'website', default: false },
  { id: 'top-pages', label: 'Top Landing Pages', section: 'website', default: false },
  { id: 'order-kpis', label: 'Order KPIs', section: 'orders', default: true },
  { id: 'orders-chart', label: 'Orders Over Time', section: 'orders', default: true },
  { id: 'order-status', label: 'Order Status', section: 'orders', default: true },
  { id: 'recent-orders', label: 'Recent Orders', section: 'orders', default: true },
  { id: 'orders-by-hour', label: 'Orders by Hour', section: 'orders', default: false },
  { id: 'del-kpis', label: 'Delivery KPIs', section: 'deliveries', default: true },
  { id: 'del-chart', label: 'Deliveries Over Time', section: 'deliveries', default: true },
  { id: 'del-zones', label: 'Delivery Zones', section: 'deliveries', default: true },
  { id: 'del-status', label: 'Delivery Status', section: 'deliveries', default: true },
  { id: 'del-time-chart', label: 'Avg Time by Zone', section: 'deliveries', default: false },
]

export const defaultWidgetIds = WIDGETS.filter((w) => w.default).map((w) => w.id)

export const CAT_COLOR: Record<string, string> = {
  Flower: C_MOCK.green,
  'Pre-Rolls': C_MOCK.blue,
  Vapes: C_MOCK.purple,
  Edibles: C_MOCK.orange,
  Concentrates: C_MOCK.teal,
  Tinctures: C_MOCK.blueLt,
  Accessories: C_MOCK.t2,
}

export function scaleChart<T extends Record<string, unknown>>(
  data: T[],
  scale: number,
  keys: (keyof T)[],
): T[] {
  return data.map((d) => {
    const out = { ...d }
    keys.forEach((k) => {
      const v = d[k]
      if (typeof v === 'number') {
        ;(out as Record<string, unknown>)[k as string] = Math.round(v * scale)
      }
    })
    return out
  })
}

export const newVsReturning = [
  { date: 'Mar 1', new: 38, ret: 112 },
  { date: 'Mar 5', new: 44, ret: 128 },
  { date: 'Mar 9', new: 52, ret: 134 },
  { date: 'Mar 13', new: 48, ret: 122 },
  { date: 'Mar 17', new: 61, ret: 148 },
  { date: 'Mar 21', new: 68, ret: 162 },
  { date: 'Mar 23', new: 72, ret: 174 },
]

export const topCustomers = [
  { name: 'Sarah M.', orders: 8, spend: 640, last: 'Mar 21', badge: 'VIP' },
  { name: 'James T.', orders: 7, spend: 588, last: 'Mar 20', badge: 'VIP' },
  { name: 'Priya K.', orders: 6, spend: 492, last: 'Mar 22', badge: 'Loyal' },
  { name: 'Mike W.', orders: 5, spend: 420, last: 'Mar 18', badge: 'Loyal' },
  { name: 'Aisha R.', orders: 5, spend: 390, last: 'Mar 19', badge: 'Loyal' },
  { name: 'Chris B.', orders: 4, spend: 310, last: 'Mar 17', badge: 'Regular' },
]

export const acqSource = [
  { source: 'Organic Search', value: 42, color: C_MOCK.green },
  { source: 'Direct', value: 28, color: C_MOCK.blue },
  { source: 'Referral', value: 16, color: C_MOCK.purple },
  { source: 'Social', value: 9, color: C_MOCK.orange },
  { source: 'Other', value: 5, color: C_MOCK.t3 },
]

export const seoTimeline = [
  { date: 'Mar 1', sessions: 820, clicks: 410 },
  { date: 'Mar 5', sessions: 940, clicks: 480 },
  { date: 'Mar 9', sessions: 1100, clicks: 520 },
  { date: 'Mar 13', sessions: 980, clicks: 490 },
  { date: 'Mar 17', sessions: 1240, clicks: 610 },
  { date: 'Mar 21', sessions: 1380, clicks: 680 },
  { date: 'Mar 23', sessions: 1420, clicks: 710 },
]

export const topKeywords = [
  { kw: 'weed delivery Vancouver', clicks: 420, impr: 8200, ctr: '5.1%', pos: 3.2 },
  { kw: 'dispensary near me', clicks: 380, impr: 12400, ctr: '3.1%', pos: 4.8 },
  { kw: 'cannabis store Richmond', clicks: 310, impr: 6800, ctr: '4.6%', pos: 2.9 },
  { kw: 'buy pre-rolls online BC', clicks: 280, impr: 5400, ctr: '5.2%', pos: 3.5 },
  { kw: 'best indica strains BC', clicks: 210, impr: 4200, ctr: '5.0%', pos: 4.1 },
  { kw: 'cannabis delivery Burnaby', clicks: 184, impr: 3800, ctr: '4.8%', pos: 4.4 },
]

export const topPages = [
  { page: '/weed-delivery-vancouver', sessions: 1840, conv: '4.2%', rev: 3200 },
  { page: '/flower', sessions: 1420, conv: '3.8%', rev: 2800 },
  { page: '/pre-rolls', sessions: 1190, conv: '5.1%', rev: 3600 },
  { page: '/buy-pre-rolls-richmond', sessions: 840, conv: '6.3%', rev: 2100 },
  { page: '/vapes', sessions: 720, conv: '3.2%', rev: 1400 },
  { page: '/cannabis-delivery-burnaby', sessions: 610, conv: '4.8%', rev: 1800 },
]

export const trafficSource = [
  { name: 'Organic', value: 42, color: C_MOCK.green },
  { name: 'Direct', value: 28, color: C_MOCK.blue },
  { name: 'Referral', value: 16, color: C_MOCK.purple },
  { name: 'Social', value: 9, color: C_MOCK.orange },
  { name: 'Paid', value: 5, color: C_MOCK.teal },
]

export const ordersTimeline = [
  { date: 'Mar 1', online: 42, inStore: 98 },
  { date: 'Mar 3', online: 38, inStore: 88 },
  { date: 'Mar 5', online: 51, inStore: 102 },
  { date: 'Mar 7', online: 46, inStore: 96 },
  { date: 'Mar 9', online: 62, inStore: 118 },
  { date: 'Mar 11', online: 58, inStore: 110 },
  { date: 'Mar 13', online: 71, inStore: 128 },
  { date: 'Mar 15', online: 64, inStore: 122 },
  { date: 'Mar 17', online: 82, inStore: 138 },
  { date: 'Mar 19', online: 76, inStore: 132 },
  { date: 'Mar 21', online: 91, inStore: 148 },
  { date: 'Mar 23', online: 87, inStore: 142 },
]

export const recentOrders = [
  { id: '#ORD-4821', customer: 'Sarah M.', items: 3, total: 87, channel: 'online' as const, status: 'completed' as const, time: '2h ago' },
  { id: '#ORD-4820', customer: 'James T.', items: 2, total: 62, channel: 'in-store' as const, status: 'completed' as const, time: '3h ago' },
  { id: '#ORD-4819', customer: 'Priya K.', items: 4, total: 124, channel: 'online' as const, status: 'processing' as const, time: '3h ago' },
  { id: '#ORD-4818', customer: 'Unknown', items: 1, total: 38, channel: 'in-store' as const, status: 'completed' as const, time: '4h ago' },
  { id: '#ORD-4817', customer: 'Mike W.', items: 2, total: 76, channel: 'online' as const, status: 'pending' as const, time: '5h ago' },
  { id: '#ORD-4816', customer: 'Aisha R.', items: 3, total: 94, channel: 'online' as const, status: 'completed' as const, time: '6h ago' },
  { id: '#ORD-4815', customer: 'Unknown', items: 2, total: 48, channel: 'in-store' as const, status: 'cancelled' as const, time: '7h ago' },
  { id: '#ORD-4814', customer: 'Chris B.', items: 1, total: 42, channel: 'online' as const, status: 'completed' as const, time: '8h ago' },
]

export const ordersByHour = [
  { hour: '8am', orders: 8 }, { hour: '9am', orders: 14 }, { hour: '10am', orders: 22 },
  { hour: '11am', orders: 31 }, { hour: '12pm', orders: 42 }, { hour: '1pm', orders: 38 },
  { hour: '2pm', orders: 36 }, { hour: '3pm', orders: 44 }, { hour: '4pm', orders: 52 },
  { hour: '5pm', orders: 61 }, { hour: '6pm', orders: 58 }, { hour: '7pm', orders: 48 },
  { hour: '8pm', orders: 38 }, { hour: '9pm', orders: 24 }, { hour: '10pm', orders: 14 },
]

export const deliveriesTimeline = [
  { date: 'Mar 1', completed: 38, scheduled: 12 },
  { date: 'Mar 5', completed: 44, scheduled: 14 },
  { date: 'Mar 9', completed: 52, scheduled: 18 },
  { date: 'Mar 13', completed: 48, scheduled: 16 },
  { date: 'Mar 17', completed: 61, scheduled: 22 },
  { date: 'Mar 21', completed: 68, scheduled: 24 },
  { date: 'Mar 23', completed: 72, scheduled: 26 },
]

export const delTimeByZone = [
  { zone: 'Downtown', time: 28 },
  { zone: 'Richmond', time: 34 },
  { zone: 'Burnaby', time: 31 },
  { zone: 'N.Van', time: 42 },
  { zone: 'Surrey', time: 48 },
  { zone: 'Coquitlam', time: 44 },
]

export const deliveryZones = [
  { zone: 'Downtown Vancouver', del: 412, avgTime: '28 min', onTime: '94%', rev: 18400, trend: 8.2 },
  { zone: 'Richmond', del: 284, avgTime: '34 min', onTime: '91%', rev: 12800, trend: 14.1 },
  { zone: 'Burnaby', del: 198, avgTime: '31 min', onTime: '92%', rev: 8900, trend: 6.4 },
  { zone: 'North Vancouver', del: 142, avgTime: '42 min', onTime: '88%', rev: 6200, trend: 18.6 },
  { zone: 'Surrey', del: 118, avgTime: '48 min', onTime: '86%', rev: 5100, trend: 22.4 },
  { zone: 'Coquitlam', del: 84, avgTime: '44 min', onTime: '89%', rev: 3600, trend: 11.8 },
]

